module.exports = __webpack_public_path__ + "img/values-img-2.1ffb9f99.svg";